// extracted by mini-css-extract-plugin
module.exports = {"root":"SignUp_root__eG13L","formWidthContainer":"SignUp_formWidthContainer__19EVZ","oinq":"SignUp_oinq__JD9zI","oinqIn":"SignUp_oinqIn__S70PV"};